import { twMerge } from 'tailwind-merge';

interface PageTitleProps {
  title: string | React.ReactNode;
  subTitle?: string | React.ReactNode;
  subTitleIconClassName?: string;
  totalItems?: number;
  className?: string;
}

export const PageTitle = ({
  title,
  subTitle,
  subTitleIconClassName,
  totalItems,
  className,
}: PageTitleProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-2.5">
        <h1 className={twMerge('font-bold text-xl', className)}>{title}</h1>
        {subTitle && (
          <div className="flex items-center bg-gray-200 text-slate-600 py-[3px] px-3.5 text-2sm gap-2">
            <div className="flex justify-center items-center">
              <i
                className={twMerge('ki-outline text-lg', subTitleIconClassName)}
              />
            </div>
            <div className="mt-[2px] flex justify-center items-center">
              {subTitle}
            </div>
          </div>
        )}
      </div>
      {totalItems !== undefined && (
        <div className="flex justify-center items-center text-2sm pt-[1.5px] pb-[0.5px] px-1.75 text-gray-78819D border border-gray-DCDFE8 bg-secondary-light rounded-[5px] shadow-2sm dark-mode:bg-coal-500 dark-mode:border-gray-300">
          {totalItems}
        </div>
      )}
    </div>
  );
};
